/* eslint-disable */
(function ($) {
  // Replace contenttable with o-table
  $('table.contenttable').removeClass('contenttable').addClass('o-table');
  $('table.o-table').each(function () {
    let tableColumnCount = 0;
    $(this).find('tr').each(function () {
      tableColumnCount = tableColumnCount < $(this).children().length ? $(this).children().length : tableColumnCount;
    });
    const parentBox = $(this).parent();
    if (tableColumnCount > 2) {
      // Add missing table wrapper
      if (!parentBox.hasClass('o-scrollable-content') && !parentBox.hasClass('tableWrap')) {
        $(this).wrap('<div class="o-scrollable-content"></div>');
      }
      // Handling already existing table wrapper
      else if (parentBox.hasClass('tableWrap')) {
        parentBox.removeClass('tableWrap').addClass('o-scrollable-content');
      }
    }
    // If table has exactly 2 columns or less, unwrap the table, add o-table--responsive class
    else if (tableColumnCount <= 2) {
      if (parentBox.hasClass('tableWrap')) {
        $(this).unwrap();
      }
      $(this).addClass('o-table--responsive');
    }
  });
})($);
(function ($) {
  $('#pmSidebar').html($('#maskSidebar').html());
  $('#maskSidebar').html('');
})($);